import { platformBrowserDynamic } from "@angular/platform-browser-dynamic";

import { AppModule } from "../../../app.module";

export class ApplicationLoaderService {
    private static _instance: ApplicationLoaderService;

    public static instance(): ApplicationLoaderService {
        if (!this._instance) {
            this._instance = new ApplicationLoaderService();
        }

        return this._instance;
    }

    public boot(): void {
        platformBrowserDynamic().bootstrapModule(AppModule).catch(error => console.error(error));
    }
}
